if (!customElements.get('announcement-bar-slider')) {
  class AnnouncementBarSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      this.initSlider(swiperOptions);

      window.addEventListener('shopify:section:load', e => {
        this.initSlider(swiperOptions);
      });

      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimeout);
        this.resizeTimeout = setTimeout(() => {
          this.initSlider(swiperOptions);
        }, 150);
      });
    }

    initSlider(swiperOptions) {
      if (this.slider) {
        this.slider.destroy(true, true);
      }

      const isDesktop = window.matchMedia('(min-width: 750px)').matches;

      let sliderOptions = {
        slidesPerView: isDesktop ? swiperOptions.slidesPerViewDesktop || 'auto' : swiperOptions.slidesPerView || 1,
        resistanceRatio: 0.72,
        loop: isDesktop
          ? Object.prototype.hasOwnProperty.call(swiperOptions, 'loopDesktop')
            ? swiperOptions.loopDesktop
            : swiperOptions.loop || false
          : swiperOptions.loop || false,
        speed: swiperOptions.speed || 500,
        allowTouchMove: swiperOptions.allowTouchMove || true,
        autoplay: isDesktop ? false : swiperOptions.autoplay || false
      };

      this.slider = new Swiper(this, sliderOptions);
    }
  }

  customElements.define('announcement-bar-slider', AnnouncementBarSlider);
}